// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2tt48","upload":"Small_upload__3tPNx","imageWrap":"Small_imageWrap__3vx4k","removeBtn":"Small_removeBtn__AVoaz"};